import { render, staticRenderFns } from "./u-table.vue?vue&type=template&id=ee373b22&"
import script from "./u-table.vue?vue&type=script&lang=tsx&"
export * from "./u-table.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports